import { DashboardInstitutionalFilterOption } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    institutionalOption: DashboardInstitutionalFilterOption;
}

/////////////////////////////////////////////////////////////////////////////////////

export const RenderGraphInstitutionalInfo: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    var msg = props.institutionalOption == DashboardInstitutionalFilterOption.Both
        ? t("Views.Dashboards.PublicationAnalysis.GraphInstitutionalInfo.Both")
        : props.institutionalOption == DashboardInstitutionalFilterOption.OnlyInstitutional
            ? t("Views.Dashboards.PublicationAnalysis.GraphInstitutionalInfo.OnlyInstitutional")
            : t("Views.Dashboards.PublicationAnalysis.GraphInstitutionalInfo.NotInstitutional");

    return <div>{msg}</div>;
};